class Select {
  constructor(element, runOnChange) {
    this.element = element
    this.runOnChange = runOnChange
    this.options = getFormattedOptions(element.querySelectorAll('option'))
    this.customElement = document.createElement('div')
    this.labelElement = document.createElement('span')
    this.optionsCustomElement = document.createElement('ul')
    setupCustomElement(this)
    element.style.display = 'none'
    element.after(this.customElement)
  }

  get selectedOption() {
    return this.options.find(option => option.selected)
  }

  get selectedOptionIndex() {
    return this.options.indexOf(this.selectedOption)
  }

  selectValue(value) {
    const newSelectedOption = this.options.find(option => {
      return option.value === value
    })
    const prevSelectedOption = this.selectedOption
    prevSelectedOption.selected = false
    prevSelectedOption.element.selected = false

    newSelectedOption.selected = true
    newSelectedOption.element.selected = true

    this.labelElement.innerText = newSelectedOption.label

    this.optionsCustomElement
      .querySelector(`[data-value="${prevSelectedOption.value}"]`)
      .classList.remove('selected')
    const newCustomElement = this.optionsCustomElement.querySelector(`[data-value="${newSelectedOption.value}"]`)
    newCustomElement.classList.add('selected')
    newCustomElement.scrollIntoView({block: 'nearest'})
  }

  onChange() {
    this.runOnChange(this.selectedOption)
  }
}

function open(select) {
  select.optionsCustomElement.classList.toggle('show')
}

function close(select) {
  select.optionsCustomElement.classList.remove('show')
}

function setupCustomElement(select) {
  select.customElement.classList.add('custom-select-container')
  select.customElement.tabIndex = 0

  select.labelElement.classList.add('custom-select-value')
  select.labelElement.innerText = select.selectedOption.label
  select.customElement.append(select.labelElement)

  select.optionsCustomElement.classList.add('custom-select-options')
  select.options.forEach(option => {
    const optionElement = document.createElement('li')
    optionElement.classList.add('custom-select-option')
    optionElement.classList.toggle('selected', option.selected)
    optionElement.innerText = option.label
    optionElement.dataset.value = option.value
    optionElement.addEventListener('click', () => {
      select.selectValue(option.value)
      select.optionsCustomElement.classList.remove('show')
      select.onChange()
    })
    select.optionsCustomElement.append(optionElement)
  })

  select.customElement.append(select.optionsCustomElement)

  select.labelElement.addEventListener('click', () => {
    select.optionsCustomElement.classList.toggle('show')
  })

  select.customElement.addEventListener('blur', () => {
    select.optionsCustomElement.classList.remove('show')
  })

  let debounceTimeout
  let searchTerm = ''
  //Keyboard controls
  select.customElement.addEventListener('keydown', (e) => {
    switch (e.code) {
      case 'Space':
        select.optionsCustomElement.classList.toggle('show')
        break
      case 'ArrowUp': {
        const prevOption = select.options[select.selectedOptionIndex - 1]
        if (prevOption) {
          select.selectValue(prevOption.value)
        }
        break
      }
      case 'ArrowDown': {
        const nextOption = select.options[select.selectedOptionIndex + 1]
        if (nextOption) {
          select.selectValue(nextOption.value)
        }
        break
      }
      case 'Enter':
      case 'Esc':
        select.optionsCustomElement.classList.remove('show')
        break
      default: {
        clearTimeout(debounceTimeout)
        searchTerm += e.key
        debounceTimeout = setTimeout(() => {
          searchTerm = ''
        }, 500)

        const searchedOption = select.options.find(option => {
          return option.label.toLowerCase().startsWith(searchTerm)
        })

        if (searchedOption) {
          select.selectValue(searchedOption.value)
        }
      }
    }
  })
}

// LOOPS through the options and returns a value
function getFormattedOptions(optionElements) {
  return [...optionElements].map(option => {
    return {
      value: option.value,
      label: option.label,
      selected: option.selected,
      element: option
    }
  })
}


const path = window.location.pathname.split('/')
path.shift();

function initializeCustomSelects() {
  const selectElements = document.querySelectorAll('[data-custom-select]')
  selectElements.forEach(selectElements => {
    new Select(selectElements, runOnChange)
  })
}

function onLoadSelect() {
  const selects = document.querySelectorAll('[data-custom-select]')
  let cookie = getCookie('blogFilter') ? JSON.parse(getCookie('blogFilter')) : []

  if (cookie.length === 0) {
    initializeCustomSelects()
    return
  }

  if (!path.includes('tagged')) {
    initializeCustomSelects()
    return
  }

  Object.keys(selects).forEach((ind) => {
    const ele = selects[ind]

    for (let i = 0, optionLength = ele.options.length; i < optionLength; i++) {

      if (cookie.includes(ele.options[i].value)) {
        ele.options[i].selected = true
      }
    }
  })

  initializeCustomSelects()

  // SCROLL TO FILTER VIEWS
  const y = selects[0].getBoundingClientRect().top + window.scrollY + -100

  window.scrollTo({
    top: y,
    behavior: 'smooth'
  })
}


function runOnChange(val) {
  // console.log('this is a test', val)
  selectChange()
}

function resetChange() {
  window.location.href = window.location.origin + '/blogs' + path[1] + '/'
}

function selectChange() {
  const items = document.querySelectorAll('.custom-select-option.selected')
  let str = ''
  let url = ''
  const arr = []

  items.forEach((item, index) => {
    const attribute = item.getAttribute('data-value')

    if (attribute !== '0') {
      if (str === '') {
        str = attribute.replaceAll(' ', '-')
        arr[index] = attribute
      } else {
        str += '+' + attribute.replaceAll(' ', '-')
        arr[index] = attribute
      }
    }
  })

  if (arr.length === 0) {
    url = window.location.origin + '/blogs/' + path[1] + '/'
  } else {
    url = window.location.origin + '/blogs/' + path[1] + '/tagged/' + str
  }

  document.cookie = 'blogFilter=' + JSON.stringify(arr) + '; path=/; max-age=' + 60 * 1000 //In milliseconds
  window.location.href = url
}

function getCookie(name) {
  let cookie = {};
  document.cookie.split(';').forEach(function (el) {
    let [k, v] = el.split('=');
    cookie[k.trim()] = v;
  })
  return cookie[name];
}

onLoadSelect()
